import { IonButton } from "@ionic/react";
import { useEffect, useState } from "react";
import useHxfTranslation from "../../../../../../barrel/hooks/useHxfTranslation";
import HxfIonPopup from "../../../HxfIonPopup/HxfIonPopup";
import styles from "./ActionScreenProduceTransformationFromProductStock.module.scss";
import useActionPreConfirm from "../../../../../../barrel/hooks/useActionPreConfirm";
import DefineProductPopup, { IDefineProductPopupShortcutProduct } from "../../../../statePopups/defineProductPopup/DefineProductPopup";
import DefineProductQuantityPopup from "../../../../statePopups/defineProductQuantityPopup/DefineProductQuantityPopup";
import DefineProductRemainsPopup from "../../../../statePopups/defineProductRemainsPopup/DefineProductRemainsPopup";
import { useProductionOrderSelectionStore } from "../../../../../FeaturePages/ProductionOrders/Standard/store/productionOrderSelectionStore";
import { useActionScreenManagerStore } from "../../ActionScreensManager/ActionScreenManagerStore";
import ProductService from "../../../../../../barrel/services/productService";
interface IProps{
    callbackOnClose?:any;
    callbackEnableConfirm?:any;
    callbackSuccessConfirm?:any;

}
function ActionScreenProduceTransformationFromProductStock(props:IProps){
    const {t} = useHxfTranslation();

    const [didMount, setDidMount] = useState(false);

    const [transformingFromProduct, setTransformingFromProduct] = useState<any>({});
    const [currentStep, setCurrentStep] = useState<"SELECT_A_PRODUCT" | "SET_QUANTITY" | "SET_ASK_REMAINS">("SELECT_A_PRODUCT");

    const preConfirm = useActionPreConfirm();

  const productionOrderSelectionStore = useProductionOrderSelectionStore();
  const currentActionScreenManager = useActionScreenManagerStore();

    const isAllowedToSelectProductFreely = () => {
  
        return currentActionScreenManager?.currentActionConfig?.freeProductSelection === 1;
    }

    const isProductAConsumption = (idProduct:any, arrayProductParameterizedVariables:any) => {

        let productKey = ProductService().buildProductKey(idProduct, arrayProductParameterizedVariables);
   

        let arrayProductBom = productionOrderSelectionStore?.product?.arrayProductBom;
        
        for(let i = 0; i<arrayProductBom?.length; i++){
            let idProduct =productionOrderSelectionStore?.product?.arrayProductBom[i]?.Id_ProductChild;
            
            let arrayProductParameterizedVariables = productionOrderSelectionStore?.product?.arrayProductBom[i]?.arrayProductParameterizedVariables ? productionOrderSelectionStore?.product?.arrayProductBom[i]?.arrayProductParameterizedVariables : [];
            let productBomKey = ProductService().buildProductKey(idProduct, arrayProductParameterizedVariables);
            if(productKey === productBomKey){
                return true;
            }
        }
        
 
        return false;
    }
    const getArrayProductSelectionShortcuts = () => {

        let arrayProductsSelectionShortcuts:IDefineProductPopupShortcutProduct[] = [];
        if(currentActionScreenManager?.currentActionConfig?.shortcutsTransformInStgProductMatchOperationConsIgnorePVVS === 1){
            //add staged material that matches operation consumption (ignoring pvvs) as shortcuts

            let idCurrentOperation = productionOrderSelectionStore?.currentOperation?.Id;
            let arrayProductBom = productionOrderSelectionStore?.product?.arrayProductBom;

            let stagedMaterial = productionOrderSelectionStore?.stagedMaterial;

            let ignorePPVVS = true; // this setting is specifically to ignore PPVVS in : shortcutsTransformInStgProductMatchOperationConsIgnorePVVS
            if(stagedMaterial){

                for(let i = 0; i<arrayProductBom?.length; i++){
                    let idProduct =productionOrderSelectionStore?.product?.arrayProductBom[i]?.Id_ProductChild;
                    let name = productionOrderSelectionStore?.product?.arrayProductBom[i]?.childProduct_name;
                    let code = productionOrderSelectionStore?.product?.arrayProductBom[i]?.childProduct_code;
                    let arrayProductParameterizedVariables = productionOrderSelectionStore?.product?.arrayProductBom[i]?.arrayProductParameterizedVariables ? productionOrderSelectionStore?.product?.arrayProductBom[i]?.arrayProductParameterizedVariables : [];
                    if(arrayProductBom?.[i]?.Id_OperationProduct && parseInt(arrayProductBom?.[i]?.Id_OperationProduct) === parseInt(idCurrentOperation)){
                    
                        
                        //check if there is any staged material that matches it
                        for(let j = 0; j<stagedMaterial.length; j++){
                            let stagedIdProduct = stagedMaterial[j]?.Id_Product;
                            let stagedArrayPPVS = stagedMaterial[j]?.arrayProductParameterizedVariables ? stagedMaterial[j]?.arrayProductParameterizedVariables : [];
                            
                            let bomProductKey = ProductService().buildProductKey(idProduct, ignorePPVVS ? [] : arrayProductParameterizedVariables);
                            let stagedProductKey = ProductService().buildProductKey(stagedIdProduct, ignorePPVVS ? [] : stagedArrayPPVS);
                            if(bomProductKey === stagedProductKey){
                                arrayProductsSelectionShortcuts.push({
                                    Id_Product:idProduct,
                                    name:name,
                                    code:code,
                                    arrayProductParameterizedVariables:arrayProductParameterizedVariables
                                });
                             
                            }
                        }
         
                    }
                }
            }
        }
        if(currentActionScreenManager?.currentActionConfig?.shortcutsTransformInOperationConsumptions === 1){

            let idCurrentOperation = productionOrderSelectionStore?.currentOperation?.Id;
            let arrayProductBom = productionOrderSelectionStore?.product?.arrayProductBom;
           
            for(let i = 0; i<arrayProductBom?.length; i++){
                let idProduct =productionOrderSelectionStore?.product?.arrayProductBom[i]?.Id_ProductChild;
                let name = productionOrderSelectionStore?.product?.arrayProductBom[i]?.childProduct_name;
                let code = productionOrderSelectionStore?.product?.arrayProductBom[i]?.childProduct_code;
                let arrayProductParameterizedVariables = productionOrderSelectionStore?.product?.arrayProductBom[i]?.arrayProductParameterizedVariables ? productionOrderSelectionStore?.product?.arrayProductBom[i]?.arrayProductParameterizedVariables : [];
                if(arrayProductBom?.[i]?.Id_OperationProduct && parseInt(arrayProductBom?.[i]?.Id_OperationProduct) === parseInt(idCurrentOperation)){
                 
                    arrayProductsSelectionShortcuts.push({
                        Id_Product:idProduct,
                        name:name,
                        code:code,
                        arrayProductParameterizedVariables:arrayProductParameterizedVariables
                    });
                }
            }
        }
 
        //clean repeated
        let mapAlreadyAdded:any = {};
        let cleanArrayProductsSelectionShortcuts:IDefineProductPopupShortcutProduct[] = [];
        for(let i = 0; i<arrayProductsSelectionShortcuts.length; i++){
            let idProduct = arrayProductsSelectionShortcuts[i]?.Id_Product;
            let arrayProductParameterizedVariables = arrayProductsSelectionShortcuts[i]?.arrayProductParameterizedVariables ? arrayProductsSelectionShortcuts[i]?.arrayProductParameterizedVariables : [];
            let productKey = ProductService().buildProductKey(idProduct, arrayProductParameterizedVariables);
            if(mapAlreadyAdded[productKey]){
                continue;
            }
            mapAlreadyAdded[productKey] = true;
            cleanArrayProductsSelectionShortcuts.push(arrayProductsSelectionShortcuts[i]);
        }
        return cleanArrayProductsSelectionShortcuts;
    }

    const preparedBaseProduct = () => {

        return {
            Id_Product:transformingFromProduct.Id_Product,
            name:transformingFromProduct.name,
            code:transformingFromProduct.code,
            arrayProductParameterizedVariables:transformingFromProduct?.arrayProductParameterizedVariables ? JSON.parse(JSON.stringify(transformingFromProduct?.arrayProductParameterizedVariables)) : []
        };

    }

    useEffect(() => {
        if(!didMount){

        }
    },[didMount]);



    if(currentStep === "SELECT_A_PRODUCT"){
        return (
            <DefineProductPopup title={t('product.transformation')} onClose={() => {
                props.callbackOnClose();
            }}
            arrayProductsSelectionShortcuts={getArrayProductSelectionShortcuts()}
            disableProductSelectionInput={!isAllowedToSelectProductFreely()}
            customContent1={(<div className={styles.selectInitialProduct}>{t('select.the.initial.product')}</div>)} onConfirm={(result:any) => {

                let transformingFromProductObj = result;

                let isConsumption = isProductAConsumption(transformingFromProductObj.Id_Product, transformingFromProductObj.arrayProductParameterizedVariables);
                let markAsNormalConsumptionIfMatchesConsumption = currentActionScreenManager?.currentActionConfig?.markAsNormalConsumptionIfMatchesConsumption === 1;
                if(isConsumption && markAsNormalConsumptionIfMatchesConsumption){
                    transformingFromProductObj.isNormalConsumption = true;
                }

                let SKIP_QTY_SET = true;
                if(SKIP_QTY_SET){
                    transformingFromProductObj.Quantity = 1;
                    setTransformingFromProduct(JSON.parse(JSON.stringify(transformingFromProductObj)));
                    setCurrentStep("SET_ASK_REMAINS");
                }else{
                    setTransformingFromProduct(JSON.parse(JSON.stringify(transformingFromProductObj)));
                    setCurrentStep("SET_QUANTITY");
                }

            }}/>
        )
    }

    if(currentStep === "SET_QUANTITY"){
        return (
            <DefineProductQuantityPopup
            deprecatedModePopup={true}
                onClosePopup={() => {
                    props.callbackOnClose();
                }}
                onSuccessConfirm={(res:any) => {
                    setTransformingFromProduct({...transformingFromProduct, Quantity: res?.quantityResult ? res?.quantityResult: 0});
                    setCurrentStep("SET_ASK_REMAINS");
                }}
                title={t('quantity')}
                productData={transformingFromProduct}
            />
        )
    }

    if(currentStep === "SET_ASK_REMAINS"){
        return (
            <DefineProductRemainsPopup baseProduct={preparedBaseProduct()} onClose={() => {
                props.callbackOnClose();
            }} onConfirm={(result:any) => {
                let remains = result.remains;

                props.callbackSuccessConfirm({transformations:[
                    {
                        remains:remains,
                        transformingFromProduct:transformingFromProduct
                    }
                ]});
            }}/>
        )
    }



    return (
    
        <>
        <HxfIonPopup title={t('product.transformation')} content={(
            <div>
               this action is not available yet
            </div>
        )} onClose={() => {
            props.callbackOnClose();
        }} modelSettings={{contentHeightPct:80,customPopupMinHeight:'80vh'}} bottomConfirmationContainer={(
            <div style={{marginTop:5,marginBottom:5}}>

                <div>
                <IonButton
                        disabled={false}
                        className={styles.btnConfirm}
                        data-btn={"select-a-product-confirm-btn"}
                        size="large"
                        onClick={() => {
                            if(!preConfirm.check()){
                                return;
                            }
                            let resultObj= {};
                            props.callbackSuccessConfirm(resultObj);
                        }}
                        >
                        
                        {t("confirm")}
                        </IonButton>

                </div> 
            </div>
        )}/>
        </>
    )
}

export default ActionScreenProduceTransformationFromProductStock;